<template>
  <div>
    <div class="grid-x">
      <div class="cell auto">
        <h2 class="text-bold">Text Message</h2>
      </div>
      <div class="cell shrink">
        <a class="no-color padding-right-small" @click="$emit('expand')"><span class="fas fa-expand"></span></a>
      </div>
    </div>
    <send-sms  class="margin-top-large" :contact="contact" @close="$emit('close')"></send-sms>
  </div>
</template>

<script>
import SendSms from '../../../components/Sms/SendSms'

export default {
  components: {
    SendSms
  },
  props: {
    contact: Object
  }
}
</script>
